import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './ls-systems-menu';
import './ls-drawer';
import './ls-profile-dropdown';
import { type RoleInfo } from '../types/leishan';

@customElement('ls-header')
export class LsHeader extends LitElement {
    static styles = css`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100..900&display=swap');

        :host {
            font-family: 'Noto Sans TC', sans-serif;
        }

        .ls-header {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            background-color: #fff;
            box-shadow: 0px 4px 6px 0px #0000001a;
        }

        .ls-header-container {
            display: grid;
            grid-template-rows: 50px;
            box-sizing: border-box;
            width: 1280px;
            padding: 0 20px;
            margin: 0 auto;
        }

        .title {
            display: flex;
            align-items: center;
        }

        .title-content {
            flex: 1 1 auto;
        }

        ls-drawer {
            display: none;
        }

        ls-systems-menu.pc {
            border-top: 1px solid #dcdfe4;
        }

        @media (max-width: 1280px) {
            .ls-header {
                box-shadow: 0px 4px 6px 0px #0000001a;
            }

            .ls-header-container {
                grid-template-rows: 50px;
                width: 100%;
            }

            ls-systems-menu.pc {
                display: none;
            }

            ls-drawer {
                display: flex;
                margin-right: 20px;
            }
        }

        @media (max-width: 576px) {
            .ls-header-container {
                grid-template-rows: 60px;
            }

            ls-systems-menu.pc {
                display: none;
            }

            ls-profile-dropdown {
                display: none;
            }
        }
    `;

    @property({ type: String }) clientId: string = '';
    @property({ type: String }) name: string = '';
    @property({ type: Boolean, attribute: 'is-show-drawer' }) isShowDrawer: boolean = false;
    @property({ type: Object, attribute: 'roleInfo' }) roleInfo: RoleInfo = {};

    render() {
        return html`<header class="ls-header">
            <div class="ls-header-container">
                <div class="title">
                    <div class="title-content">
                        <slot></slot>
                    </div>
                    ${this.name
                        ? html`<ls-profile-dropdown
                              name="${this.name}"
                              .roleInfo=${this.roleInfo}
                          ></ls-profile-dropdown>`
                        : ''}
                </div>
            </div>
        </header>`;
    }
}
